<template>
  <div>
    <form
      ref="form"
      data-url="/accreditations/applications/payment"
      :class="{ 'loading-opacity': preloader }"
      enctype="multipart/form-data"
    >
      <div class="row">
        <div class="col-12">
          <app-note
            class="mb-danger"
            :show-title="false"
            :notes="['Todos los campos con un (*) son obligatorios.']"
          />
        </div>
        <div class="col-6">
          <div class="form-group">
            <label
              >Comprobante de pago:
              <strong class="text-danger">*</strong></label
            >
            <app-input
              type="file"
              :label="file ? file.name : $t('upload_your_file')"
              v-model="file"
              v-if="!inputs.license_payment_file"
            />
            <div class="mt-2">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(inputs, 'license_payment_file')"
                v-if="inputs.license_payment_file"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>

              <button
                type="submit"
                class="btn btn-danger"
                @click.prevent="confirmed('license_payment_file')"
                v-if="inputs.license_payment_file"
                :required="true"
              >
                <app-icon name="trash-2" />
                {{ $t("delete") }}
              </button>
            </div>
          </div>
        </div>
        <br />
        <div class="col-12 mt-3">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            v-if="!inputs.license_payment_file"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>

          <br />
        </div>

        <div class="col-12">
          <br /><br />
          <app-note
            class="mb-info"
            :title="$t('Información de pago')"
            content-type="html"
            :notes="[
              'Para conocer el valor de la licencia si es adquisición por primera vez o renovación, comunicarse con sisac@acreditacion.gob.ec.<br/><br/><b>DEPÓSITO O TRANSFERENCIA BANCARIA:</b><br/>Banco: Banco del Pacífico<br/>Cuenta: Corriente No. 8322996<br/>Nombre: DARWIN ALEXANDER QUINTANA HERMOSA<br/>RUC RIMPE: 1793211748001<br/>Correo electrónico: sisac@acreditacion.gob.ec<br/><b>NOTA:</b> El comprobante de depósito o la confirmación de la transferencia deberá subir a SISAC. Después se subir el comprobante dar clic en procesar.<br/><br/><b>PAGO CON TARJETA DE CRÉDITO:</b><br/>Si elige esta forma de pago, envíenos su solicitud por el correo electrónico: sisac@acreditacion.gob.ec con el Asunto: PAGO CON TARJETA DE CRÉDITO y le enviamos un enlace de Datafast para que pueda realizar la transacción de pago de una forma 100% segura desde su computador o dispositivo.<br/><b>NOTA:</b> El comprobante de la transacción deberá subir a SISAC.<br/><br/><b>Activación de la Licencia</b><br/>Para los dos casos, se verifica que la transacción sea efectiva en un plazo de 48 horas y se activa su licencia. Recibirá una notificación cuando su cuenta esté activa y podrá hacer uso del SISAC.<br/><br/><b>Información Adicional</b><br/>Para más información, comuníquese con sisac@acreditacion.gob.ec <br/>Guías, manuales y preguntas frecuentes en la página web www.acreditacion.gob.ec, menú SISAC<br/><br/>¡Gracias por usar SISAC!.'
            ]"
          />
        </div>
      </div>

      <app-confirmation-modal
        v-if="deleteModal"
        modal-id="delete"
        @confirmed="confirm"
        @cancelled="cancelled"
      />
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiUrl";

export default {
  mixins: [FormMixin],
  components: {},

  data() {
    return {
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      preloader: false,
      inputs: {},
      file: null,
      deleteModal: false,
      selected: "",
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  created() {
    // this.data();
    this.dataLicense();
  },

  methods: {
    openFileTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    cancelled() {
      this.deleteModal = false;
    },

    beforeSubmit() {
      this.preloader = true;
    },

    // data() {
    //   let url = `${actions.ACCREDITATIONS_APPLICATIONS}/form/${this.$store.state.accreditation.id}`;
    //   this.axiosGet(url).then((response) => {
    //     this.inputs = response.data;
    //   });
    // },

    dataLicense() {
      let url = `${actions.ACCREDITATIONS_APPLICATIONS}/showLicense/${this.$store.state.accreditation.id}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
      });
    },

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      this.isAddEditModalActive = false;
    },

    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      formData.append(
        "acc_app_id",
        this.$store.state.accreditation.id
      );
      formData.append(
        "file",
        this.file
      );
      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.inputsEval = data;
      this.$toastr.s(this.$t("updated_success"));
      this.dataLicense();
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    confirmed(fileName) {
      this.inputs[fileName] = null;
      this.file = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName, key) {
      if (key) {
        const w = window.open(key, "_blank");
        w.focus();
      } else {
        const w = window.open(obj[fileName].path, "_blank");
        w.focus();
      }
    },
  },
};
</script>
